import React from "react";
var __jsx = React.createElement;
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import Layout from "@/_LayoutsRelated/layout/Layout";
import stl from "@/pages/financing/Financing.module.css";
import { PageNamesEnum } from "@/routes/routes";
import CarsPricesLanding from "@/pages/car-prices/CarsPricesLanding/CarsPricesLanding";
import CarsPricesMakes from "@/pages/car-prices/CarsPricesMakes/CarsPricesMakes";
import CarsPricesMakesModels from "@/pages/car-prices/CarsPricesMakesModels/CarsPricesMakesModels";
import CarsPricesMakesModelsYears from "@/pages/car-prices/CarsPricesMakesModelsYears/CarsPricesMakesModelsYears";
import FAQSection from "@/pages/car-prices/components/FAQSection";
var CarsPricesPageRoot = function CarsPricesPageRoot() {
  var carsPricesResponse = useFullPageData(PageNamesEnum.PAGE_NAME__CarPricesPageRoot);
  var pageContent;
  switch (carsPricesResponse.slug) {
    case "cars-prices-landing":
      pageContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CarsPricesLanding, carsPricesResponse), /*#__PURE__*/React.createElement(FAQSection, {
        carPriceInsights: carsPricesResponse.car_price_insights
      }));
      break;
    case "cars-prices-make":
      pageContent = /*#__PURE__*/React.createElement(CarsPricesMakes, carsPricesResponse);
      break;
    case "cars-prices-make-model":
      pageContent = /*#__PURE__*/React.createElement(CarsPricesMakesModels, carsPricesResponse);
      break;
    case "cars-prices-make-model-year":
      pageContent = /*#__PURE__*/React.createElement(CarsPricesMakesModelsYears, carsPricesResponse);
      break;
    default:
      pageContent = /*#__PURE__*/React.createElement("div", null, "Wrong Cars Prices page");
  }
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true,
    mainClass: stl.mainFinancingClass
    // customStikeyButton={
    //     <a
    //         className={["redBtn"].join(" ")}
    //         style={{
    //             width: "90%",
    //             padding: "20px",
    //             margin: "0 auto",
    //             height: "48px",
    //             marginTop: "7px",
    //             borderRadius: "4px",
    //         }}
    //         href={createUrl("/autos")}
    //     >
    //         {t("تصفح جميع السيارات ", {ns: "financing_page"})}
    //     </a>
    // }
  }, pageContent);
};
export default CarsPricesPageRoot;